import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  // Vérifier si la classe contient 'text-white', ce qui indique que nous sommes sur la page d'accueil sans défilement
  const isWhiteText = className.includes('text-white');
  
  return (
    <Link to="/" className={`flex items-center ${className}`}>
      <img 
        src={logo} 
        alt="MGE COUVERTURE Logo" 
        className="h-12 w-auto mr-3" 
      />
      <div className="text-lg font-poppins font-bold">
        <span className="text-primary">MGE</span>
        <span className={isWhiteText ? "text-white" : "text-gray-800"}> COUVERTURE</span>
      </div>
    </Link>
  );
};

export default Logo;
